/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { getDefaultAdGroup } from '../../native-ads/constants';

export const defaultNativeAdGroup = {
  getDefaultAdGroup,
  defaultProperties: ['Name', 'FrequencyCapSettings', 'CpmBid', 'SearchBid', 'UseOptimizedTargeting', 'AdRotation'],
  setCustomProperties: (data) => {
    data.StartDate = new Date();
  },
  defaultTargetingProperties: ['ageRanges', 'genderTypes', 'deviceTypes', 'initialDeviceTypes'],
  setCustomTargetingProperties: _.noop,
};

export const defaultDealAdGroup = {
  getDefaultAdGroup,
  defaultProperties: ['Name', 'FrequencyCapSettings'],
  setCustomProperties: (data) => {
    data.StartDate = new Date();
  },
  defaultTargetingProperties: [],
  setCustomTargetingProperties: _.noop,
};

export const defaultCTVAdGroup = {
  getDefaultAdGroup,
  defaultProperties: ['Name', 'FrequencyCapSettings'],
  setCustomProperties: (data) => {
    data.StartDate = new Date();
  },
  defaultTargetingProperties: ['ageRanges', 'genderTypes'],
  setCustomTargetingProperties: _.noop,
};
